var render = function render(){var _vm=this,_c=_vm._self._c;return _c('table',{style:(_vm.wrapperHeight),attrs:{"id":"wrapper"}},[_c('tr',{style:(_vm.setHeight)},[_c('td',[_c('br'),_c('br'),_c('h5',[_vm._t("empty_state_text")],2)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }